"use client";

import { navigationIcon } from "../../components/workspace/navigation/NavigationIcon";
import type { NavItem } from "../../components/workspace/navigation/types";
import { workspaceApplicationCatalogCategories } from "./catalogCategories";

type Translate = (key: string) => string;

export function getAppsNavigation(
  workspaceBase: string,
  t: Translate = (key) => key,
  catalogT: Translate = (key) => key,
) {
  return {
    homeItem: {
      label: t("home"),
      applicationId: "apps",
      matchPrefix: `${workspaceBase}/apps`,
      sidebarSlot: "apps",
      children: [
        [
          `${workspaceBase}/apps`,
          t("applications"),
          { exact: true, icon: navigationIcon("catalog") },
        ],
        [
          `${workspaceBase}/apps/presets`,
          t("presets"),
          { icon: navigationIcon("templates") },
        ],
        {
          label: t("categories"),
          matchPrefix: `${workspaceBase}/apps/category`,
          icon: navigationIcon("catalog"),
          children: workspaceApplicationCatalogCategories.map((category) => [
            `${workspaceBase}/apps/category/${category}`,
            catalogT(`categories.${category}`),
          ]),
        },
      ],
    } satisfies NavItem,
  };
}
